import { useState } from "react";
import "./Login.css";

const HERO_IMAGE = "/bg_login.png";

// Change to your API URL
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const APP_VERSION = import.meta.env.VITE_APP_VERSION 

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    try {
      setLoading(true);
      setMessage("Signing in...");

      const response = await fetch(
        `${API_BASE_URL}/api/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: username.trim(),
            password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.detail || "Invalid username or password"
        );
      }

      // Store ONLY JWT
      sessionStorage.setItem(
        "access_token",
        data.access_token
      );

      setMessage("Login successful");

      window.location.href = "/";
    } catch (err: any) {
      setMessage(
        "Login failed: " +
          (err.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-root">
      <div className="login-shell">

        {/* Left Hero Section */}
        <div className="login-hero">
          <img
            src={HERO_IMAGE}
            className="login-hero-image"
            alt="Hero"
          />
          <div className="login-hero-overlay" />

          <div className="login-hero-text">
            <p className="hero-kicker">
              AI GENERATIVE
            </p>

            <h2 className="hero-title">
              Anything you can imagine
            </h2>

            <p className="hero-subtitle">
              Generate insights and answers with
              your AI Agent.
            </p>
          </div>
        </div>

        {/* Right Panel */}
        <div className="login-panel">
          <div className="login-panel-inner">

            <p className="panel-kicker">
              LOGIN TO YOUR ACCOUNT
            </p>

            <h1 className="panel-title">
              Welcome Back!
            </h1>

            <p className="panel-subtitle">
              Enter your username and password
              to continue
            </p>

            {/* Username */}
            <div className="form-field">
              <label className="field-label">
                Username
              </label>

              <div className="field-wrapper">
                <span className="field-icon">
                  👤
                </span>

                <input
                  type="text"
                  className="field-input"
                  placeholder="Your Username"
                  value={username}
                  onChange={(e) =>
                    setUsername(e.target.value)
                  }
                />
              </div>
            </div>

            {/* Password */}
            <div className="form-field">
              <label className="field-label">
                Password
              </label>

              <div className="field-wrapper">
                <span className="field-icon">
                  🔒
                </span>

                <input
                  type="password"
                  className="field-input"
                  placeholder="Your password"
                  value={password}
                  onChange={(e) =>
                    setPassword(e.target.value)
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleLogin();
                    }
                  }}
                />
              </div>
            </div>

            {/* Sign In */}
            <button
              className="primary-button"
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>

            {/* Status */}
            {message && (
              <p className="login-status">
                {message}
              </p>
            )}
            {/* Version */}
            <p className="login-version">
              v{APP_VERSION}
            </p>
            {/* Copyright */}
            <p className="login-copyright">
              © {new Date().getFullYear()} askndone.com. All rights reserved.
           </p>
          </div>
        </div>
      </div>
    </div>
  );
}